import React from "react";
import ScrollAnimation from "../components/ScrollAnimation";
import "./Services.css";

const Services = () => {
  const services = [
    {
      title: "Her Türlü Kompresör Bakım ve Onarımı",
      description:
        "Tüm marka ve modellerde kompresörlerin bakım ve onarım hizmetlerini uzman ekibimizle gerçekleştiriyoruz.",
      features: [
        "Arıza teşhisi ve onarım",
        "Motor revizyon işlemleri",
        "Kompresör vida grubu revizyonu",
        "Elektrik panosu bakımı",
      ],
    },
    {
      title: "Jeneratör Bakım ve Onarımı",
      description:
        "Dizel ve benzinli jeneratörlerin profesyonel bakım ve onarım hizmetlerini deneyimli teknisyenlerimizle sunuyoruz.",
      features: [
        "Motor revizyon işlemleri",
        "Alternatör tamiri",
        "Kontrol panosu bakımı",
        "Yakıt sistemi temizliği",
      ],
    },
    {
      title: "Blower Bakım ve Onarımı",
      description:
        "Endüstriyel blower ve fan sistemlerinin bakım, onarım ve performans optimizasyonu hizmetlerini veriyoruz.",
      features: [
        "Fan kanatları bakımı",
        "Motor yatak değişimi",
        "Vibrasyon analizi",
        "Hava akış optimizasyonu",
      ],
    },
    {
      title: "Periyodik Bakımlar",
      description:
        "Kompresörünüzün uzun ömürlü ve verimli çalışması için düzenli periyodik bakım programları uyguluyoruz.",
      features: [
        "Aylık rutin kontroller",
        "Yağ değişimi",
        "Filtre değişimi",
        "Performans ölçümleri",
      ],
    },
    {
      title: "Yedek Parça Temin ve Montajı",
      description:
        "Orijinal ve kaliteli yedek parça temini ile montaj hizmetlerini aynı gün içerisinde sunuyoruz.",
      features: [
        "Orijinal yedek parça",
        "Hızlı tedarik",
        "Profesyonel montaj",
        "Garanti kapsamı",
      ],
    },
    {
      title: "Yeni Kompresör Satış ve Kiralama Temin",
      description:
        "İhtiyaçlarınıza uygun yeni kompresör satışı ve kurulum hizmetleri sunuyoruz.",
      features: [
        "Marka çeşitliliği",
        "Kapasiteli stok",
        "Rekabetçi fiyatlar",
        "Hızlı teslimat",
      ],
    },
    {
      title: "Gerekli Mühendislik Hesaplamalarının Yapılması",
      description:
        "Yeni kompresör satışında tesislerinize uygun kompresör seçimi için gerekli teknik hesaplamaları ve projelendirme hizmetlerini sağlıyoruz.",
      features: [
        "Hava ihtiyacı hesaplama",
        "Enerji verimliliği analizi",
        "Sistem tasarımı",
        "Teknik raporlama",
      ],
    },
    {
      title: "Kompresör Kurulum ve Devreye Alma",
      description:
        "Yeni kompresörlerin profesyonel kurulumu, bağlantıları ve devreye alınması hizmetlerini uzman ekibimizle gerçekleştiriyoruz.",
      features: [
        "Profesyonel kurulum",
        "Elektrik bağlantıları",
        "Hava hattı montajı",
        "Test ve devreye alma",
      ],
    },
    {
      title: "7/24 Teknik Destek Sağlanması",
      description:
        "Acil durumlarda kesintisiz hizmet için günün her saati ulaşılabilir teknik destek hizmeti veriyoruz.",
      features: [
        "7/24 telefon desteği",
        "Acil müdahale ekibi",
        "Uzaktan diagnoz",
        "Hızlı çözüm süreci",
      ],
    },
  ];

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1 className="page-title">Hizmetlerimiz</h1>
          <p className="page-subtitle">
            Kompresör ihtiyaçlarınızın her aşamasında yanınızdayız. Satış öncesi
            danışmanlıktan bakım hizmetlerine kadar geniş hizmet yelpazemiz.
          </p>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          <section className="services-section">
            <div className="services-grid">
              {services.map((service, index) => (
                <ScrollAnimation
                  key={index}
                  direction="left"
                  delay={index * 150}
                >
                  <div className="service-card">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                    <ul className="service-features">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          <section className="contact-cta">
            <div className="cta-content">
              <h2>Hizmetlerimiz Hakkında Daha Fazla Bilgi</h2>
              <p>
                Kompresör ihtiyaçlarınız için en uygun hizmeti seçmek ve detaylı
                bilgi almak için bizimle iletişime geçin.
              </p>
              <div className="cta-buttons">
                <a
                  href="https://wa.me/905342137564"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  WhatsApp ile iletişime geçin
                </a>
                <a href="tel:+905342137564" className="btn btn-primary">
                  Hemen Arayın
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Services;
